/* Import all plugins from tiny-slider */
import { tns } from "tiny-slider";

const elCount = (document.querySelector('.slideshow').childElementCount) - 1;
const randIndex = Math.floor(Math.random() * elCount);


function init() {
  const outer = document.querySelector('.tns-outer')
  outer.style.width = "900px";
  outer.classList.add('mt-8');
  
  const controls = document.querySelector('.custom-controls');
  outer.appendChild(controls);
  
  const view = document.getElementById('tns1-mw');
  const viewRect = view.getBoundingClientRect();
  
  const prev = document.querySelector('.prev-button');
  const next = document.querySelector('.next-button');
  const prevRect = prev.getBoundingClientRect();
  
  // padding between edge of slideshow viewport and element
  const offset = 10;
  
  prev.style.top = `${(viewRect.height / 2) - prevRect.height / 2 - 18}px`
  next.style.top = `${(viewRect.height / 2) - prevRect.height / 2 - 18}px`
  
  next.style.left = `${viewRect.width - prevRect.width - offset}px`
  prev.style.left = `${offset}px`
  
  const yearButtonIndexArray = [];
  const slidesYearArray = [];
  
  const slides = document.querySelectorAll('.views-row.tns-item li');
  for (let s of slides) {
    slidesYearArray.push(parseInt(s.getAttribute('class')));
  }
  
  const yearArray = [];
  
  for (let i = 0; i < slides.length; ++i) {
    if (!yearArray.includes(slidesYearArray[i])) {
      if (slidesYearArray[i] % 5 == 0) {
        yearArray.push(slidesYearArray[i]);
        yearButtonIndexArray.push(i);
      }
    }
  }
  
  const nav = document.querySelector('.tns-nav');
  const yearButtons = document.querySelectorAll('.tns-nav button');
  
  for (let i = 0, j = 0; i < yearButtons.length; ++i) {
    if (!yearButtonIndexArray.includes(i)) {
      yearButtons[i].classList.add('hide-important');
    } else {
      const yearText = document.createElement('div');
      yearText.classList.add('year-text');
      yearText.textContent = slidesYearArray[i];
      yearButtons[i].appendChild(yearText);
      if (++j == yearButtonIndexArray.length) {
        yearButtons[i].classList.add('last-nav');
      }
    }
  }

  // const slideshowElement = document.querySelector('.tns-outer');
  // slideshowElement.addEventListener('mouseover', () => {
  //   controls.classList.remove('invisible');
  // });
  // slideshowElement.addEventListener('mouseout', () => {
  //   controls.classList.add('invisible'); 
  // });

}

const slider = tns({
  // autoplay: true,
  // center: true,
  container: ".slideshow",
  // edgePadding: 0,
  // gutter: 0,
  items: 3,
  loop: false,
  startIndex: randIndex,
  prevButton: '.prev-button',
  nextButton: '.next-button',
  // speed: 200,
  arrowKeys: true,
  onInit: init,
  navAsThumbnails: true,
});
  // slider.getInfo().slideItems[slider.getInfo().index].classList.add('tns-item-active');
  /* Export all plugins from tiny-slider */
export default tns;
  